import { render, staticRenderFns } from "./OrdersFlyoutComponent.vue?vue&type=template&id=464ffea6&"
import script from "./OrdersFlyoutComponent.vue?vue&type=script&lang=ts&"
export * from "./OrdersFlyoutComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464ffea6')) {
      api.createRecord('464ffea6', component.options)
    } else {
      api.reload('464ffea6', component.options)
    }
    module.hot.accept("./OrdersFlyoutComponent.vue?vue&type=template&id=464ffea6&", function () {
      api.rerender('464ffea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flyout/340th/OrdersFlyoutComponent.vue"
export default component.exports